export const NOTIFICATION_REFRESH_INTERVAL = 10000;
